import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const Card = styled(motion.div)`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.05);

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 30px 40px rgba(211, 149, 255, 0.1);
  }
`;

const ImageContainer = styled.div`
  position: relative;
  height: 280px;
  overflow: hidden;
  background: #f8f8f8;
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);

  ${Card}:hover & {
    transform: scale(1.08);
  }
`;

const Badge = styled.span`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  padding: 0.4rem 1rem;
  border-radius: 30px;
  font-size: 0.8rem;
  font-weight: 600;
  color: #d395ff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(211, 149, 255, 0.2);
`;

const ProductInfo = styled.div`
  padding: 1.8rem;
`;

const ProductCategory = styled.span`
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #d395ff;
  font-weight: 600;
`;

const ProductName = styled.h3`
  font-size: 1.4rem;
  font-weight: 600;
  color: #0a0a0a;
  margin: 0.5rem 0;
  line-height: 1.3;
`;

const ProductDescription = styled.p`
  color: #666;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const ProductCard = ({ product, index }) => {
  // Ensure is_featured is treated as boolean
  const isFeatured = product.is_featured === '1' || product.is_featured === 1 || product.is_featured === true;
  
  return (
    <Card
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ y: -8 }}
    >
      <ImageContainer>
        <ProductImage 
           src={product.image_url ? `https://kemlo.in/backend${product.image_url}` : 'https://placehold.co/300x280/d395ff/white?text=Kemlo'}
          alt={product.name}
          onError={(e) => {
            e.target.src = 'https://placehold.co/300x280/d395ff/white?text=Kemlo';
          }}
        />
        {isFeatured && <Badge>Featured</Badge>}
      </ImageContainer>
      
      <ProductInfo>
        <ProductCategory>{product.category}</ProductCategory>
        <ProductName>{product.name}</ProductName>
        <ProductDescription>{product.description?.substring(0, 80)}...</ProductDescription>
      </ProductInfo>
    </Card>
  );
};

export default ProductCard;